module.exports = __webpack_public_path__ + "img/overlay.6c01b5fa.png";